const formatPhoneNumber = (phoneNumber) => phoneNumber.replaceAll(/[() -]/g, '')

export default formatPhoneNumber